function isTouchDevice(): boolean {
  return !!navigator.maxTouchPoints && navigator.maxTouchPoints > 1
}

export default isTouchDevice
